import React from 'react';
import PropTypes from 'prop-types';
import { Home, Building, Calendar, Coins } from 'lucide-react';
import { isUK, isUKOrIreland } from '../../utils/countries';
import { formatPrice } from '../../utils/currency';

import './PropertyDetails.scss';

/**
 * Detail row component
 */
var DetailRow = function(props) {
    var label = props.label;
    var value = props.value;
    var Icon = props.icon;

    if (!value) return null;

    return (
        <div className="al-property-detail-row">
            {Icon && (
                <div className="al-property-detail-icon">
                    <Icon size={16} />
                </div>
            )}
            <span className="al-property-detail-label">{label}</span>
            <span className="al-property-detail-value">{value}</span>
        </div>
    );
};

/**
 * PropertyDetails Component
 * Displays UK/Ireland specific property details like Tenure, Council Tax, etc.
 */
var PropertyDetails = function(props) {
    var countryId = props.countryId;
    var tenure = props.tenure;
    var councilTaxBand = props.councilTaxBand;
    var groundRent = props.groundRent;
    var leaseYearsRemaining = props.leaseYearsRemaining;
    var heritageStatus = props.heritageStatus;

    // Only show for UK/Ireland properties
    if (!isUKOrIreland(countryId)) return null;

    // Check if we have any data to show
    var hasData = tenure || councilTaxBand || groundRent || leaseYearsRemaining || heritageStatus;
    if (!hasData) return null;

    // Format ground rent with currency
    var formattedGroundRent = null;
    if (groundRent) {
        formattedGroundRent = formatPrice(groundRent, countryId) + '/year';
    }

    // Format lease years
    var formattedLeaseYears = null;
    if (leaseYearsRemaining) {
        formattedLeaseYears = leaseYearsRemaining + ' years';
    }

    // Council Tax is UK only
    var showCouncilTax = isUK(countryId) && councilTaxBand;

    return (
        <div className="al-property-details">
            <h3 className="al-property-details-title">Property Information</h3>
            <div className="al-property-details-grid">
                <DetailRow
                    label="Tenure"
                    value={tenure}
                    icon={Home}
                />
                {showCouncilTax && (
                    <DetailRow
                        label="Council Tax"
                        value={'Band ' + councilTaxBand}
                        icon={Building}
                    />
                )}
                <DetailRow
                    label="Lease Remaining"
                    value={formattedLeaseYears}
                    icon={Calendar}
                />
                <DetailRow
                    label="Ground Rent"
                    value={formattedGroundRent}
                    icon={Coins}
                />
                {heritageStatus && (
                    <DetailRow
                        label="Heritage Status"
                        value={heritageStatus}
                    />
                )}
            </div>
        </div>
    );
};

PropertyDetails.propTypes = {
    countryId: PropTypes.number,
    tenure: PropTypes.string,
    councilTaxBand: PropTypes.string,
    groundRent: PropTypes.number,
    leaseYearsRemaining: PropTypes.number,
    heritageStatus: PropTypes.string
};

export default PropertyDetails;
